import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'
import { getCities, getSelectedCity } from 'src/store/data.store'
import { setSelectedCityId } from 'src/store/app.state.store'
import { Popup } from 'components/Utility/Popup/Popup'
import { Arrow } from 'components/Utility/Arrow/Arrow'
import { CityPicker } from 'components/PageElements/CityPicker/CityPicker'
import styles from './CurrentCity.module.scss'

/** Cookie the SSR server reads to render prices and salons for the client's city */
export const CITY_COOKIE = 'cityId'

type CurrentCityProps = {
  active: boolean,
  onClick: () => void,
  onClosePicker: () => void,
}

export const CurrentCity: React.FC<CurrentCityProps> = (props) => {
  const { onClick, active, onClosePicker } = props
  const dispatch = useDispatch()
  const selectedCity = useSelector(getSelectedCity)
  const cities = useSelector(getCities)

  const handleSelect = useCallback((id: number) => {
    if (typeof document !== 'undefined') {
      Cookies.set(CITY_COOKIE, String(id))
    }
    dispatch(setSelectedCityId(id))
    onClosePicker()
  }, [dispatch, onClosePicker])

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick()
  }

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.text}>
        <span className={styles.mobileText}>Ваш город </span>
        <span className={styles.cityNameContainer}>
          <span className={styles.cityName}>
            {selectedCity?.city?.name ?? '...'}
          </span>
          <Popup
            backDropClassName={styles.popupBackDrop}
            className={styles.popup}
            place={'headerNav'}
            active={active}
            onClose={onClosePicker}
          >
            <CityPicker
              cities={cities}
              selectedCityId={selectedCity?.city?.id ?? null}
              onSelectCity={handleSelect}
            />
          </Popup>
        </span>
      </div>
      <Arrow className={styles.arrow} direction={active ? 'down' : 'right'} />
    </div>
  )
}
